<div class="page">
  @if (showVerCaso) {
    <app-ver-caso
      [caso]="casoSeleccionado"
      [subcategoria]="subcategoriaCompleta"
      [categoria]="casoSeleccionado?.Categoria1__c || ''"
      categoriaType="Llámanos"
      [selectedEstacion]="selectedEstacionComplete"
      [ocultarApelacionNoDisponible]="true"
      (closeVerCaso)="onCloseVerCaso()"
      (apelacionIngresada)="onApelacionIngresada($event)"
    />
  } @else {
    <div class="restricted-width">
      <div class="page-title"><b>Llámanos |</b> Historial Llamanos</div>
      <hr class="page-title-hr" />
      <div class="filters-container">
        @if (isArcoprime) {
          <div class="filter-container">
            <div class="filter-title required">ID PAGADOR</div>
            <div class="filter">
              <ng-select
                [items]="pagadores"
                bindLabel="label"
                bindValue="id_pagador"
                [(ngModel)]="selectedPagador"
                (ngModelChange)="onPagadorChange($event)"
                [clearable]="false"
                [searchable]="true"
                placeholder="Seleccionar"
              />
            </div>
          </div>
        }
        <div class="filter-container">
          <div class="filter-title required">ESTACIÓN DE SERVICIO</div>
          <div class="filter">
            <ng-select
              [items]="edsOptions"
              bindLabel="label"
              bindValue="value"
              [(ngModel)]="selectedEstacion"
              (ngModelChange)="onEstacionChange($event)"
              [clearable]="false"
              [searchable]="false"
              placeholder="Seleccionar"
            />
          </div>
        </div>
        <div class="filter-container">
          <div class="filter-title required">PERÍODO</div>
          <div class="filter">
            <ng-select
              [items]="periodos"
              bindLabel="name"
              bindValue="id"
              [(ngModel)]="selectedPeriodo"
              (ngModelChange)="onPeriodoChange($event)"
              [clearable]="true"
              [searchable]="false"
              placeholder="Seleccionar"
            />
          </div>
        </div>
        <div class="filter-container">
          <div class="filter-title">CATEGORÍA</div>
          <div class="filter">
            <ng-select
              [items]="categorias"
              bindLabel="name"
              bindValue="name"
              [(ngModel)]="selectedCategoria"
              (ngModelChange)="onCategoriaChange($event)"
              [clearable]="true"
              [searchable]="false"
              placeholder="Seleccionar"
            />
          </div>
        </div>
        <div class="filter-container">
          <div class="filter-title">SUBCATEGORÍA</div>
          <div class="filter">
            <ng-select
              [items]="subcategorias"
              bindLabel="name"
              bindValue="name"
              [(ngModel)]="selectedSubcategoria"
              (ngModelChange)="applyFilters()"
              [clearable]="true"
              [readonly]="!selectedCategoria"
              [searchable]="false"
              placeholder="Seleccionar"
            />
          </div>
        </div>
        <div class="filter-container">
          <div class="filter-title">ESTADO</div>
          <div class="filter">
            <ng-select
              [items]="estados"
              bindLabel="name"
              bindValue="name"
              [(ngModel)]="selectedEstado"
              (ngModelChange)="applyFilters()"
              [clearable]="true"
              [searchable]="false"
              placeholder="Seleccionar"
            />
          </div>
        </div>
        <div class="filters-container-right">
          <input
            type="text"
            class="search-input"
            placeholder="Buscar..."
            [(ngModel)]="searchTerm"
            (ngModelChange)="applyFilters()"
          />
        </div>
      </div>

      <div class="table-container">
        <table
          class="table"
          tableScrollSync
          aria-label="Listado de solicitudes de Llamanos"
        >
          <thead>
            <tr>
              <th class="width-122">
                <div class="th-data">
                  <div class="th-text">N° de Caso</div>
                </div>
              </th>
              <th class="width-112">
                <div class="th-data">
                  <div class="th-text th-text--double-row">
                    Fecha de<br />Ingreso
                  </div>
                </div>
              </th>
              <th class="width-132">
                <div class="th-data">
                  <div class="th-text">Origen</div>
                </div>
              </th>
              <th class="width-172">
                <div class="th-data">
                  <div class="th-text">Categoría</div>
                </div>
              </th>
              <th class="width-172">
                <div class="th-data">
                  <div class="th-text">Subcategoría</div>
                </div>
              </th>
              <th class="width-128">
                <div class="th-data">
                  <div class="th-text">Estado</div>
                </div>
              </th>
              <th class="width-152">
                <div class="th-data">
                  <div class="th-text th-text--double-row">
                    Fecha Estimada<br />Resolución
                  </div>
                </div>
              </th>
              <th class="width-152">
                <div class="th-data">
                  <div class="th-text th-text--double-row">
                    Fecha<br />Resolución
                  </div>
                </div>
              </th>
              <th class="width-96">
                <div class="th-data">
                  <div class="th-text">VER</div>
                </div>
              </th>
            </tr>
          </thead>

          <tr class="table-separator-row-border-top"></tr>

          <tbody>
            @for (caso of casos; track $index) {
              <tr class="data">
                <td class="width-122 caso-numero-cell">
                  @if (caso.numeroCasoReferenciado) {
                    <span class="warning-tooltip-wrapper">
                      <img
                        src="assets/warning-azul.svg"
                        alt="referenciado"
                        class="warning-tooltip-icon"
                      />
                      <div class="warning-tooltip">
                        Caso Referenciado<br /><b
                          >N° {{ caso.numeroCasoReferenciado }}</b
                        >
                      </div>
                    </span>
                  }
                  <span
                    class="numero-caso"
                    [class.numero-caso-no-reference]="
                      !caso.numeroCasoReferenciado
                    "
                    >{{ caso.CaseNumber }}</span
                  >
                </td>
                <td class="width-112">
                  {{ formatFecha(caso.FechaCreacion__c) }}
                </td>
                <td class="width-132">{{ caso.Origin }}</td>
                <td class="width-172">
                  <div class="ellipsis-cell" ellipsisTooltip>
                    {{ caso.Categoria1__c }}
                  </div>
                </td>
                <td class="width-172">
                  <div class="ellipsis-cell" ellipsisTooltip>
                    {{ caso.Categoria2__c }}
                  </div>
                </td>
                <td class="width-128 capsula-estado-container">
                  <div
                    [ngClass]="
                      'capsula-estado ' + ESTADOS_CASOS[caso.Status]?.clase
                    "
                  >
                    {{ ESTADOS_CASOS[caso.Status]?.etiqueta }}
                  </div>
                </td>
                <td class="width-152">
                  {{ formatFecha(caso.FechaResolucionSugerida__c) }}
                </td>
                <td class="width-152">
                  {{
                    caso.ClosedDate ? formatFecha(caso.ClosedDate) : ''
                  }}
                </td>
                <td class="width-96">
                  <img
                    src="assets/ojo.svg"
                    alt="Ver"
                    class="ojo"
                    (click)="onVerCaso(caso)"
                  />
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>

      @if (hasSearched && casos.length === 0) {
        <div class="no-data-message">
          <span>No hay datos para los filtros seleccionados.</span>
        </div>
      }
    </div>
  }
  <lib-custom-alert
    [isVisible]="showAlert"
    [closeFunc]="closeAlert"
    [acceptFunc]="closeAlert"
    [hideGreyBackground]="hideGreyBackground"
    [showGreyBackground]="showGreyBackground"
    [scrollTo]="scrollTo"
    [content]="alertContent"
    [icon]="alertIcon"
    title="Error"
  >
  </lib-custom-alert>
</div>
